import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_import_file_helper_RowClass} from '../../../dbschema';

export class CouponImportFileHdrHelperContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_import_file_helper: bl_fi_mst_coupon_import_file_helper_RowClass = new bl_fi_mst_coupon_import_file_helper_RowClass();
}
